const isActiveStaffMember = (member) =>
	String(member?.status || "").toLowerCase() === "active";

// Inactive staff are not valid supervisor choices. Keep the person already
// assigned so an existing inactive supervisor still displays on the form.
export const buildSupervisorOptions = (staffList, staff) => {
	if (!Array.isArray(staffList)) {
		return [];
	}

	return staffList
		.filter((member) => member && member.id && member.id !== staff?.id)
		.filter(
			(member) =>
				isActiveStaffMember(member) || member.id === staff?.supervisor
		)
		.map((member) => ({
			label: `${member.firstName || ""} ${member.lastName || ""}`.trim(),
			value: member.id,
		}));
};
